import React, {useRef, useContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import axios from "axios";
import languageContext from "../context/language/languageContext";
import data from "../language.json";

function OtpVerify() {
  const inputRefs = useRef([]);
  const { lang, phone, setAlert, setMessage, setPhone } = useContext(languageContext);
  const [Otp, setOtp] = useState(new Array(4).fill(""));
  const [counter, setCounter] = useState(300); // 5-minute timer
  const navigate = useNavigate();
  const location = useLocation();
  const [verifyingOtp, setVerifyingOtp] = useState(false);
  const { from } = location.state || {};

  // Handle OTP input change
  const handleChange = (element, index) => {
    
    if (isNaN(element.value)) return;
    setOtp([...Otp.map((d, idx) => (idx === index ? element.value : d))]);
    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };


  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && index > 0 && !Otp[index]) {
        const newotp = [...Otp]
        newotp[index - 1] = ""
        inputRefs.current[index - 1].focus()
        setOtp(newotp)


    }
}

  // Timer for OTP resend
  useEffect(() => {
    if (counter > 0) {
      const timer = setInterval(() => setCounter(counter - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [counter]);

  // Format time to MM:SS
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  // API Request for OTP verification
  const verifyOtp = async () => {
    const otpValue = Otp.join("");

    if (otpValue.length !== 4) {
      setAlert(true);
      setMessage("Please enter a valid 6-digit OTP.");
      return;
    }

    try {
      setVerifyingOtp(true);

      const response = await axios.post(
        "https://www.careplus.gopillz.com/parent_login",
        {
          phone: phone,
          otp: otpValue,
        },
        {
          headers: {
            "Accept": "*/*",
            "Content-Type": "application/json",
          },
        }
      );

      console.log(response)

      if (response.data.access_token ||response.status==200) {
        console.log(from, "form")
        localStorage.setItem("token", response.data.access_token);
        localStorage.setItem("login", true);
        setPhone(""); // Reset phone state
        if (from === "signup") {
          navigate("/ask");
        } else {
          navigate("/login");
        }
      }
      if (response.status === 401) {
        setAlert(true);
        setMessage(response.data.msg || "OTP verification failed. Please try again.");

      }
      
    } catch (error) {
      console.log(error)
      if (error.status === 401) {
        setAlert(true);
        setMessage(error.response.data.msg || "OTP verification failed. Please try again.");

      } else {
        setAlert(true);
        setMessage(error.response.data.msg || "OTP verification failed. Please try again.");

      }
      // console.error("Error during OTP verification:", error.status);
      // setAlert(true);
      // setMessage("An error occurred. Please try again.");
    } finally {
      setVerifyingOtp(false);
    }
  };

  return (
    <div className="bg-bgall min-h-screen w-full">
      <Navbar />
      <div className="flex flex-col items-center justify-center h-[calc(100vh-100px)] px-4">
        {/* Header Text */}
        <h2 className="text-2xl font-bold mt-8">{data[lang]["auth"][2]}</h2>
        <p className="text-gray-600 mt-2 text-center">
          Enter the code sent to your registered phone number
        </p>

        {/* OTP Input Fields */}
        <div className="flex justify-center my-6 space-x-2">
          {Otp.map((digit, index) => (
            <input
            type="text"
            id={`otp-${index}`}
            key={index}
            name={`otp-${index}`}
            maxLength={1}
            value={digit}
            autoFocus={index === 0}
            ref={(ref) => { inputRefs.current[index] = ref }}
            onKeyDown={(e) => handleKeyDown(index, e)}
              className="w-10 h-10 border border-gray-300 rounded-lg text-center text-lg focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
              onChange={(e) => handleChange(e.target, index)}
              required
            />
          ))}
        </div>

        {/* Verify OTP Button */}
        <button
          onClick={verifyOtp}
          className={`w-48 bg-bluebtn text-white py-2 rounded-lg mt-4 ${
            verifyingOtp ? "opacity-50 cursor-not-allowed" : "hover:bg-blue-700"
          }`}
          disabled={verifyingOtp}
        >
          {verifyingOtp ? <div className="animate-spin h-4 w-4 border-t-2 border-white border-solid mx-auto"></div> : "Verify OTP"}
        </button>

        {/* Resend OTP Timer */}
        <div className="mt-4 text-gray-600">
          {counter > 0 ? (
            <p>Resend OTP in {formatTime(counter)}</p>
          ) : (
            <button
              className="text-blue-500 hover:underline"
              onClick={() => setCounter(300)}
            >
              Resend OTP
            </button>
          )}
        </div>

        {/* Back to Login Link */}
        <div className="mt-4">
          <a href="/login" className="text-sm text-blue-500 hover:underline">
            Back to Login
          </a>
        </div>
      </div>
    </div>
  );
}

export default OtpVerify;
